import { Edit, Visibility } from "@mui/icons-material";
import { Box, IconButton, Typography, Button, Dialog, DialogContent, CircularProgress } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { getGstrReportsClient } from "api/services/gstr/client";
import SearchContainer from "components/SearchContainer";
import Table, { ColumnType } from "components/Table";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";
import { useContext, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";
import { getGstFinancialYears } from "utils/FinancialYears";
import GstrCredentialsEdit from "views/atom-pro/Gstr/gstr-client/CreadentialEdit";
import { UserProfileContext } from "context/UserProfile";
import useTitle from "hooks/useTitle";
import React from "react";
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import FinancialYearAndMonthSelector from "views/atom-pro/Gstr/modules/Compliance/YearPeriodSelect";
import { exportGstClientReport } from "api/services/clients/gstr-clients";
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";

const GstReports = () => {
  useTitle("ATOM Pro | Reports");
  const financialYears = getGstFinancialYears();
  const [selectedYear, setSelectedYear] = React.useState(financialYears[0]);
  const selectedYearRef = React.useRef(selectedYear);
  selectedYearRef.current = selectedYear;
  const { permissions } = usePermissions();
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [search, setSearch] = useState("");
  const [showGeneratingDialog, setShowGeneratingDialog] = useState(false);
  const [generatingReport, setGeneratingReport] = useState("");
  const [sort, setSort] = useState<any>({});
  // const { data: uData } = useContext(UserProfileContext);
  // const navigate = useNavigate()
  const { data, isLoading }: ResType = useQuery(
    [
      "get-gstr-client",
      { limit: pageCount, offset: page * pageCount, search: search, sort },
    ],
    getGstrReportsClient, {
    onSuccess: (res) => {
      // setTotalCount(res?.data?.count)
    },
    enabled: permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  }
  );
  React.useEffect(() => {
    console.log("FY Changed:", selectedYear);
  }, [selectedYear]);




  const totalCount = data?.data?.count


  let defaultColumns: Array<ColumnType> = [
    {
      key: "clientId",
      title: "Client ID",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (v) => (
        <Typography      >
          {v?.client?.clientId ? v?.client?.clientId : "--"}
        </Typography>
      ),
    },
    {
      key: "displayName",
      title: "Client Name",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (v) => (
        <Typography      >
          {v?.client?.displayName}
        </Typography>
      ),
    },
    {
      key: 'profile.gstin',
      title: 'GSTIN'
    },
    {
      key: "id",
      title: "Reports",
      render: (rowData: any) => <Actions data={rowData} selectedYear={selectedYearRef.current} />,
    },
  ]
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };

  const Actions = ({
    data,
    selectedYear,
  }: {
    data: any;
    selectedYear: string;
  }) => {
    const [repostexporting, setReportExporting] = useState(false);
    const handleGstClientReportExport = async (type: string) => {
      try {
        setGeneratingReport(type);
        setShowGeneratingDialog(true);
        setReportExporting(true);
        console.log("selectedYear", selectedYear);

        const payload = {
          financialYear: selectedYear,
          clientId: data?.client?.id,
          type,
        };

        // Allow dialog to render before API starts
        await new Promise((resolve) => setTimeout(resolve, 100));

        const res = await exportGstClientReport(payload);

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileURL = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileURL;

        const clientName =
  data?.client?.displayName || "Client";

        const safeClientName = clientName.replace(
          /[\\/:*?"<>|]/g,
          ""
        );

        const formattedDateTime = getCurrentFormattedDateTime();

        link.download = `ATOM Pro - (${safeClientName}) ${type} - ${selectedYear} - Report ${formattedDateTime}.xlsx`;

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(fileURL);

        snack.success("Report generated successfully");
      } catch (error: any) {
        console.log("FULL ERROR", error);

        let message = "Failed to export GST report";

        if (error?.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const json = JSON.parse(text);

            message = json?.message || message;
          } catch (e) {
            console.error("Failed to parse blob error", e);
          }
        } else {
          message =
            error?.response?.data?.message ||
            error?.message ||
            message;
        }

        snack.error(message);
      } finally {
        setGeneratingReport("");
        setShowGeneratingDialog(false);
        setReportExporting(false);
      }
    };
    return (
      <>
        <Box sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, max-content)",
          gap: 2,
        }}>
          <>
            <Button
              size="small"
              // startIcon={<PlayArrowIcon />}
              sx={{
                whiteSpace: "nowrap",
                flexShrink: 0,
                backgroundColor: "#eff6ff",
                color: "#2563eb",
                border: "1px solid #93c5fd",
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                  borderColor: "#68aefd",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleGstClientReportExport("GSTR1")}
              disabled={repostexporting}
            >
              GSTR 1
            </Button>
            <Button
              size="small"
              // startIcon={<PlayArrowIcon />}
              sx={{
                whiteSpace: "nowrap",
                flexShrink: 0,
                backgroundColor: "#eff6ff",
                color: "#2563eb",
                border: "1px solid #93c5fd",
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                  borderColor: "#68aefd",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleGstClientReportExport("GSTR2A")}
              disabled={repostexporting}
            >
              GSTR 2A
            </Button>
            <Button
              size="small"
              // startIcon={<PlayArrowIcon />}
              sx={{
                whiteSpace: "nowrap",
                flexShrink: 0,
                backgroundColor: "#eff6ff",
                color: "#2563eb",
                border: "1px solid #93c5fd",
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                  borderColor: "#68aefd",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleGstClientReportExport("GSTR2B")}
              disabled={repostexporting}
            >
              GSTR 2B
            </Button>
            <Button
              size="small"
              // startIcon={<PlayArrowIcon />}
              sx={{
                whiteSpace: "nowrap",
                flexShrink: 0,
                backgroundColor: "#eff6ff",
                color: "#2563eb",
                border: "1px solid #93c5fd",
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                  borderColor: "#68aefd",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleGstClientReportExport("TAXLIBIT")}
              disabled={repostexporting}
            >
             Tax Liability & ITC Compare
            </Button>
            <Button
              size="small"
              // startIcon={<PlayArrowIcon />}
              sx={{
                whiteSpace: "nowrap",
                flexShrink: 0,
                backgroundColor: "#eff6ff",
                color: "#2563eb",
                border: "1px solid #93c5fd",
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                  borderColor: "#68aefd",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleGstClientReportExport("GSTR3B")}
              disabled={repostexporting}
            >
               GSTR 3B
            </Button>
            <Button
              size="small"
              // startIcon={<PlayArrowIcon />}
              sx={{
                whiteSpace: "nowrap",
                flexShrink: 0,
                backgroundColor: "#eff6ff",
                color: "#2563eb",
                border: "1px solid #93c5fd",
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                  borderColor: "#68aefd",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleGstClientReportExport("GSTR9")}
              disabled={repostexporting}
            >
              GSTR 9
            </Button>

          </>
        </Box>

      </>
    );
  };


  if (!(permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS))) {
    return <AccessDenied />
  }

  return (
    <Box m={1}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} ml={1}>
        <Box display="flex" justifyContent="flex-start">

          <SearchContainer
            debounced
            value={search}
            placeHolder="Search by Client ID | Client Name | GSTIN"
            onChange={setSearch}
          />
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <FinancialYearAndMonthSelector
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />

        </Box>
      </Box>
      <Box m={1} mb={5}>
        <Table
          sx={{ pb: 0, mb: 0, height: '525px' }}
          pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
          data={data?.data?.result || []}
          columns={columns}
          sortHandler={handleSort}
          loading={isLoading}
        />
      </Box>
      <Dialog
        open={showGeneratingDialog}
        disableEscapeKeyDown
      >
        <DialogContent
          sx={{
            textAlign: "center",
            py: 4,
            minWidth: 320,
          }}
        >
          <CircularProgress />

          <Typography mt={2} fontWeight={600}>
            Generating Report
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            mt={1}
          >
            Please wait while we generate your GST report...
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  )


}

export default GstReports;
